<template>
  <div class="columns is-centered">
    <div class="column is-5">
      <div class="login-form box">
        <h3 class="title is-5 has-text-centered">
          User Login
        </h3>
        <validation-observer
          ref="login-form"
          tag="div"
        >
          <input-form>
            <textbox-vee
              id="email-address"
              v-model="loginInfo.email"
              placeholder="E-mail"
              aria-required="true"
              aria-placeholder="E-mail address"
              rules="required"
              :value="loginInfo.email"
              required
            />

            <textbox-vee
              id="password"
              v-model="loginInfo.password"
              type="Password"
              placeholder="Password"
              required
              aria-required="true"
              aria-placeholder="Password"
              rules="required"
            />

            <div
              slot="submit"
              class="field has-text-centered"
            >
              <button
                id="login-btn"
                type="submit"
                :class="{ 'is-loading' : loading }"
                :disabled="loading"
                class="button is-primary"
                @click.prevent="login"
              >
                Login
              </button>
              <a
                class="is-block city-login-btn"
                href="javascript:;"
                @click.prevent="$store.dispatch('msal/startSession')"
              >
                Login with your @phila.gov email address
              </a>
            </div>
          </input-form>
          <div class="field forgot-password">
            <div class="is-size-6 has-text-centered">
              <router-link
                :to="'/user-registration'"
              >
                Register
              </router-link>
              &nbsp; | &nbsp;
              <router-link
                :to="'/forgot-password'"
              >
                Reset Password
              </router-link>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { withValidation } from 'vee-validate';
import { Textbox, InputForm } from '@phila/phila-ui';

const TextboxVee = withValidation(Textbox);

export default {
  name: 'LoginForm',
  components: {
    TextboxVee,
    InputForm,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      loginInfo: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    async login () {
      let isValid = await this.$refs['login-form'].validate();
      if (isValid) {
        this.$emit('login', this.loginInfo);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .login-form {
    margin: 2rem 0;
    border: 1px solid $sidewalk-grey;
    padding: 2rem 1rem 1rem;
  }
  .city-login-btn {
    margin-top: 1rem;
  }
</style>